import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import './custom-polyfill';

import { Buffer } from 'buffer';

import React from 'react';
import ReactDOM from 'react-dom/client';

// Import external styles first to ensure they are overridden by our styles when necessary
import '@fashionnovateam/nova-ui-toolkit/dist/style.css';
import './index.css';

import Main from './main';
import reportWebVitals from './reportWebVitals';

window.Buffer = Buffer;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<Main />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
